<template>
  <div class="mb-3">
    <Alert
      type="alert-info"
      text="Templates are easy way to replicate your existing bots."
    ></Alert>
    <div class="row">
      <div class="col-sm-4" v-for="(bot, index) in bots" :key="index">
        <div class="card mb-3" style="min-height:280px;">
          <div class="card-header text-center bg-dark">
            <h4 class="text-white">{{ bot.first_name }}</h4>
          </div>
          <div class="card-body text-center">
            <!--<p class="card-text">{{ item.shortDescription }}</p>-->
            <button
              type="link"
              name="button"
              class="btn btn-secondary"
              @click="toChat(bot.username)"
            >
              Chat
            </button>
            <button
              type="button"
              name="button"
              class="btn btn-secondary"
              @click="useTemplate(bot)"
            >
              Use This Template
            </button>
          </div>
        </div>
      </div>
    </div>
    <Loading :active.sync="isLoading" color="green"></Loading>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import TelegramService from "@/services/TelegramService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import Alert from "@/components/Alert.vue";

export default {
  name: "MyTemplates",
  components: {
    Loading,
    Alert
  },
  props: {
    currentBot: Object,
  },
  data: function() {
    return {
      user: this.$store.state.user,
      bots: this.$store.state.bots,
      isLoading: false,
    };
  },
  methods: {
    useTemplate: function(bot) {
      this.$dialog
        .confirm(
          "Please confirm to use '" +
            bot.first_name +
            "' template with bot '" +
            this.currentBot.first_name +
            "''"
        )
        .then(
          function() {
            this.isLoading = true;
            ApiService.getBot(this.user, bot.token)
              .then(function(result) {
                this.updateBot(this.currentBot.token, result.structure);
              }.bind(this))
              .catch(
                function(response) {
                  this.$dialog.alert(response.description);
                }.bind(this)
              )
              .finally(
                function() {
                  this.isLoading = false;
                }.bind(this)
              );
          }.bind(this)
        );
    },

    toChat: function(link) {
      link = "https://t.me/"+link
      window.open(link, "_blank");
    },

    updateBot: function(token, structure) {
      this.isLoading = true;
      ApiService.updateBot(this.user, token, structure)
        .then(
          function() {
            this.$dialog.alert("Bot updated with selected template");
            this.$emit("update");
          }.bind(this)
        )
        .catch(
          function(response) {
            if (response.status_code != null) {
              this.$dialog.alert(response.description);
            } else {
              console.log(response);
            }
          }.bind(this)
        )
        .finally(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },

    getBots() {
      if (this.bots.length == 0) {
        this.isLoading = true;
        ApiService.getUser(this.user)
          .then(
            function(result) {
              result.bots.forEach(getMe.bind(this));
              this.$store.commit("setBots", this.bots);
            }.bind(this)
          )
          .catch(
            function(response) {
              this.$dialog.alert(response.description);
            }.bind(this)
          )
          .finally(
            function() {
              this.isLoading = false;
            }.bind(this)
          );
      }

      async function getMe(token) {
        TelegramService.getMe(token)
          .then(
            function(bot) {
              bot["token"] = token;
              this.bots.push(bot);
            }.bind(this)
          )
          .catch(
            function(msg) {
              this.bots.push({
              token: token,
              first_name: "Bot deleted from Telegram",
              username: "Bot deleted from Telegram"
              })
              console.log(msg)
            }.bind(this)
          );
      }
    },
  },
  mounted() {
    this.getBots();
  },
};
</script>

<style></style>
